/**
 * Chiffrement local des saisies hors ligne (dossier §18.2) : AES-GCM 256 bits, clé NON EXTRACTIBLE générée sur le
 * poste et conservée dans IndexedDB (le navigateur la garde ; aucun code ne peut la lire en clair).
 */

export async function generateKey(subtle: SubtleCrypto = globalThis.crypto.subtle): Promise<CryptoKey> {
  return subtle.generateKey({ name: 'AES-GCM', length: 256 }, false, ['encrypt', 'decrypt']);
}

export interface Sealed {
  iv: number[];
  data: ArrayBuffer;
}

export async function seal(
  key: CryptoKey,
  value: unknown,
  subtle: SubtleCrypto = globalThis.crypto.subtle,
): Promise<Sealed> {
  const iv = globalThis.crypto.getRandomValues(new Uint8Array(12));
  const data = await subtle.encrypt(
    { name: 'AES-GCM', iv },
    key,
    new TextEncoder().encode(JSON.stringify(value)),
  );
  return { iv: [...iv], data };
}

export async function open<T>(
  key: CryptoKey,
  sealed: Sealed,
  subtle: SubtleCrypto = globalThis.crypto.subtle,
): Promise<T> {
  const plain = await subtle.decrypt({ name: 'AES-GCM', iv: new Uint8Array(sealed.iv) }, key, sealed.data);
  return JSON.parse(new TextDecoder().decode(plain)) as T;
}
